




import { OWebPassword } from "oweb";
import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WUserEditPass extends BaseComponent {
	form = getForm();

	sendForm(event: any) {
		let ctx = this,
			form: HTMLFormElement = event.target,
			o: OWebPassword = new OWebPassword(app);

		o.onError(response => {
			app.view.dialog(response);
		})
			.onSuccess(() => {
				ctx.$emit("done");
			})
			.editPass(form);
	}
}

const getForm = function() {
	return {
		fields: {
			cpass: {
				field: "input",
				label: { i18n: "OO_LANG_CURRENT_PASSWORD" },
				attrs: { name: "cpass", type: "password" }
			},
			pass: {
				field: "input",
				label: { i18n: "OO_LANG_NEW_PASSWORD" },
				attrs: { name: "pass", type: "password" }
			},
			vpass: {
				field: "input",
				label: { i18n: "OO_LANG_CONFIRM_NEW_PASSWORD" },
				attrs: { name: "vpass", type: "password" }
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
